import { App, Plugin } from "vue";
import { RouteRecordName } from "vue-router";
import { RouteNames } from '@/router/RouteNames'
import { useUserProgressStore } from "@/stores/UserProgressStore";

export class ReviewNavigator {
    /** Gets the next review step based on the current route and what deals have been selected */
    public async getNextReviewStep(currentRouteName: RouteRecordName | null | undefined): Promise<RouteNames> {
        const userProgressStore = useUserProgressStore();
        const selectedBroadBandDealId = userProgressStore.getUserProgress()?.broadbandStep.selectedBroadbandDealId;

        switch (currentRouteName) {
            case RouteNames.SecurityPlans:
                return RouteNames.MarketingPreferanceReview;
            case RouteNames.SecurityPlansAddon:
                return RouteNames.MarketingPreferanceReview;
            case RouteNames.MarketingPreferanceReview:
                return selectedBroadBandDealId ? RouteNames.OrderSummary : this.getNextReviewStep(RouteNames.OrderSummary);
            default:
                return RouteNames.Home;
        }
    }
}

export const ReviewNavigatorPlugin: Plugin = {
    install: (app: App) => {
        const navigator = new ReviewNavigator();
        app.provide('ReviewNavigator', navigator);
    }
}